export default __webpack_public_path__ + "static/media/BrokkolyBanner.33834858.png";